<div class="flex
            h-[65px]
            items-center
            mb-[10px] 
            mt-[10px]
            gap-[5px]
            pl-[20px]
            cursor-pointer
"
     (click)="navigateToDashboard()">
  <img src="assets/images/pg-logo.svg" width="35">
  <div class="flex flex-col">
    <span class="text-white uppercase font-medium">SUBS </span>
    <span class="text-white uppercase">SUBS ADMINISTRATION</span>
  </div>

</div> 
<div *ngIf="dataSource.length === 0" class="p-4 text-center text-gray-400 text-sm">
  {{ 'SIDEBAR.NO_ACCESS' | translate }}
</div>
<mat-tree
  *ngIf="dataSource.length > 0"
  #tree
  [dataSource]="dataSource"
  [treeControl]="treeControl"
  class="example-tree flex flex-col gap-[15px]"
>
  <!-- This is the tree node template for leaf nodes -->
  <!-- There is inline padding applied to this node using styles.
    This padding value depends on the mat-icon-button width. -->
  <mat-tree-node *matTreeNodeDef="let node">
    <a
      class="flex items-center gap-x-3"
      [routerLink]="[node.link]"
      ariaCurrentWhenActive="page"
      [class.active]="isActive(node.link)"
    >
      <mat-icon class="material-symbols-outlined">
        {{ node.icon }}
      </mat-icon>
      <span style="line-height: normal">{{ node.title }}</span></a
    >
  </mat-tree-node>
  <!-- This is the tree node template for expandable nodes -->
  <mat-nested-tree-node
    *matTreeNodeDef="let node; when: hasChild"
    [cdkTreeNodeTypeaheadLabel]="node.title"
  >
    <div class="mat-tree-node">
      <div class="parent-node-container" (click)="treeControl.toggle(node)" style="cursor: pointer;">
        <mat-icon class="material-symbols-outlined">
          {{ node.icon }}
        </mat-icon>
        <span style="line-height: normal">{{ node.title }}</span>
      </div>
      <button
        mat-icon-button
        matTreeNodeToggle
        [attr.aria-label]="'Toggle ' + node.title"
      >
        <mat-icon class="mat-icon-rtl-mirror">
          {{ treeControl.isExpanded(node) ? "keyboard_arrow_down" : "chevron_right" }}
        </mat-icon>
      </button>
      
    </div>
    <!-- There is inline padding applied to this div using styles.
        This padding value depends on the mat-icon-button width.  -->
   <div *ngIf="treeControl.isExpanded(node)" role="group">
      <ng-container matTreeNodeOutlet></ng-container>
    </div>
  </mat-nested-tree-node>
</mat-tree>
